export const POLLER_LAST_FAILURE_TYPES = [
  'internal',
  'external_4xx',
  'external_5xx',
  'external_network',
  'permission_error',
  'missing_data',
] as const;
